import { redirect } from "react-router-dom";
import { AuthUtils } from "../../utils/helper_functions";
import { clearAllGameContexts } from "../../utils/active-game-context";

export function  action () {
  const token = AuthUtils.getAuthToken();
  if (!token) {
    clearAllGameContexts();
    return redirect("/login");
  }
  localStorage.removeItem('token');
  clearAllGameContexts();
  return redirect('/login');
}
